/** Display labels for alert category keys the backend sends. */
export const CATEGORY_LABELS: Record<string, string> = {
  bigquery_blocked: "Blocked BigQuery queries",
  jira_blocked: "Blocked Jira queries and scope violations",
};

/**
 * Label for a category key; unknown keys (a category added server-side first)
 * render as the raw key so they stay toggleable.
 */
export function categoryLabel(key: string): string {
  return Object.prototype.hasOwnProperty.call(CATEGORY_LABELS, key)
    ? (CATEGORY_LABELS[key] ?? key)
    : key;
}

/** True when any category toggle differs; a missing key counts as off. */
export function categoriesChanged(
  saved: Record<string, boolean>,
  current: Record<string, boolean>,
): boolean {
  return Object.keys(changedCategories(saved, current)).length > 0;
}

/** Only the toggles that differ from the saved map; the backend merges per key. */
export function changedCategories(
  saved: Record<string, boolean>,
  current: Record<string, boolean>,
): Record<string, boolean> {
  const changed: Record<string, boolean> = {};
  const keys = new Set([...Object.keys(saved), ...Object.keys(current)]);
  for (const key of keys) {
    const value = current[key] ?? false;
    if ((saved[key] ?? false) !== value) changed[key] = value;
  }
  return changed;
}
